export type OperatorRole = 'READONLY' | 'SUPPORT' | 'BILLING' | 'SUPER_ADMIN';

export type Operator = {
  id: string;
  email: string;
  display_name: string;
  role: OperatorRole;
  last_login_at: string | null;
};

export type AuthTokens = {
  access_token: string;
  refresh_token: string;
  expires_in: number;
};

export type LoginResponse = AuthTokens & {
  operator: Operator;
};

const ACCESS_KEY = 'admin_access_token';
const REFRESH_KEY = 'admin_refresh_token';
const OPERATOR_KEY = 'admin_operator';

export function getAccessToken(): string | null {
  return sessionStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  return sessionStorage.getItem(REFRESH_KEY);
}

export function getOperator(): Operator | null {
  const raw = sessionStorage.getItem(OPERATOR_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Operator;
  } catch {
    return null;
  }
}

export function setAuthSession(data: LoginResponse): void {
  sessionStorage.setItem(ACCESS_KEY, data.access_token);
  sessionStorage.setItem(REFRESH_KEY, data.refresh_token);
  sessionStorage.setItem(OPERATOR_KEY, JSON.stringify(data.operator));
}

export function updateOperator(operator: Operator): void {
  sessionStorage.setItem(OPERATOR_KEY, JSON.stringify(operator));
}

export function clearAuthSession(): void {
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  sessionStorage.removeItem(OPERATOR_KEY);
}

export function isAuthenticated(): boolean {
  return Boolean(getAccessToken() && getOperator());
}

export function isSuperAdmin(): boolean {
  return getOperator()?.role === 'SUPER_ADMIN';
}

export function canGrantCredits(): boolean {
  const role = getOperator()?.role;
  return role === 'BILLING' || role === 'SUPER_ADMIN';
}

export function canAssignPlan(): boolean {
  return canGrantCredits();
}

export function canDeleteUsers(): boolean {
  return isSuperAdmin();
}
